function areAdjacentDOMRect(rect1: DOMRect, rect2: DOMRect): boolean {
  const horizontallyAdjacent = (rect1.y === rect2.y && rect1.height === rect2.height)
        && (rect1.x + rect1.width === rect2.x || rect2.x + rect2.width === rect1.x);

  const verticallyAdjacent = (rect1.x === rect2.x && rect1.width === rect2.width)
        && (rect1.y + rect1.height === rect2.y || rect2.y + rect2.height === rect1.y);

  return horizontallyAdjacent || verticallyAdjacent;
}

function mergeTwoDOMRects(rect1: DOMRect, rect2: DOMRect): DOMRect {
  const x = Math.min(rect1.x, rect2.x);
  const y = Math.min(rect1.y, rect2.y);
  const width = Math.max(rect1.x + rect1.width, rect2.x + rect2.width) - x;
  const height = Math.max(rect1.y + rect1.height, rect2.y + rect2.height) - y;

  return new DOMRect(x, y, width, height);
}

export function mergeDOMRects(rectangles: DOMRect[]): DOMRect[] {
  const merged: DOMRect[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const rect of rectangles) {
    let mergedWithExisting = false;

    for (let i = 0; i < merged.length; i++) {
      if (areAdjacentDOMRect(merged[i], rect)) {
        merged[i] = mergeTwoDOMRects(merged[i], rect);
        mergedWithExisting = true;
        break;
      }
    }

    if (!mergedWithExisting) {
      merged.push(rect);
    }
  }

  // 合成された結果をさらに合成できるか再度チェック
  let canMerge = true;
  while (canMerge) {
    canMerge = false;
    for (let i = 0; i < merged.length; i++) {
      for (let j = i + 1; j < merged.length; j++) {
        if (areAdjacentDOMRect(merged[i], merged[j])) {
          merged[i] = mergeTwoDOMRects(merged[i], merged[j]);
          merged.splice(j, 1);
          canMerge = true;
          break;
        }
      }
      if (canMerge) break;
    }
  }

  return merged;
}

export function getDOMRectsByClassName(className: string): DOMRect[] {
  // eslint-disable-next-line max-len
  const cols = document.getElementsByClassName(className) as unknown as HTMLCollection;
  const res: Element[] = [];
  for (let i = 0; i < cols.length; i++) {
    const col = cols[i];
    res.push(col);
  }
  return mergeDOMRects(res.map((col) => col.getBoundingClientRect()));
}
